import React from 'react';
import PropTypes from 'prop-types';
import RedXMark from '../../Svg/RedXMark';
import Checkmark from '../../Svg/Checkmark';
import classes from '../index.scss';
import { renderIf } from 'modules/render-if';

const bulledPointInHex = "2022";
const bulletPointCharacter = String.fromCharCode(parseInt(bulledPointInHex, 16));

const ValidationIcon = (props) => {
  const { useBullet, valid } = props;
  const icon = valid ? <Checkmark /> : <RedXMark />;

  return (
    <div className={ classes.svg }>
      {renderIf(valid || !useBullet)(() => (
        icon
      ))}

      {renderIf(!valid && useBullet)(() => (
        <span className={ `${classes["bullet-point"]}` }>{bulletPointCharacter}</span>
      ))}
    </div>
  );
};

ValidationIcon.propTypes = {
  useBullet: PropTypes.bool.isRequired,
  valid: PropTypes.bool.isRequired,
};

export default ValidationIcon;
